import client from 'api/client';
import { AxiosRequestConfig, AxiosResponse } from 'axios';

export function get(customConfig?: AxiosRequestConfig): Promise<AxiosResponse> {
    const url = '/payouts';
    return client.get<{ url: string }>(url, customConfig);
}
